import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import SecondCheckbox from "components/SecondCheckbox";
import Input from "components/Input";
import Button from "components/Button";
import { useContext, useEffect, useState } from "react";
import clientService from "api/clientService";
import CloseIcon from "assets/icons/close.svg?react";
import BinIcon from "assets/icons/bin.svg?react";
import SearchByNip from "components/SearchByNip";
import { IGUSCompany } from "dto/IGUSCompany";
import SearchCode from "components/SearchCode";
import SearchPlace from "components/SearchPlace";
import SearchAddress from "components/SearchAddress";
import TextArea from "components/TextArea";
import { Formik, useFormikContext } from "formik";
import {
  validationSchemaClient,
  validationSchemaEntity,
} from "./validation.schema";
import ClientsContext from "contexts/ClientsContext";
import { getUserId } from "utils/getUserId";
import { useAuth } from "react-oidc-context";
import { IClient } from "dto/IClient";
import { useTranslation } from "react-i18next";

interface IContact {
  FirstName: string;
  LastName: string;
  Phone: string;
  Email: string;
  JobPosition: string;
}

const EditClientModal: FC<Props> = ({
  label,
  client,
  onClose,
  onCancel,
  onSave,
  newClient = false,
}) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const userId = getUserId(auth.user!);

  const LS = localStorage.getItem(`${userId ?? ""}.layout`);
  const sizes = JSON.parse(LS ?? "[]");
  const { mutate: updateClient } = clientService.useUpdateClient();
  clientService.useGetClient(client?.Id ?? "", false);

  useContext(ClientsContext);

  const [metData] = useState<any>({
    Name: client?.Name ?? "",
    ZipCode: client?.ZipCode ?? "",
    City: client?.City ?? "",
    Address: client?.Address ?? "",
    Phone: client?.Phone ?? "",
    Email: client?.Email ?? "",
    Note: client?.Note ?? "",
    IsInstitution: client?.IsInstitution ?? false,
    Nip: client?.NIP ?? "",
    REGON: client?.REGON ?? "",
    cityId: null as string | null,
    addressId: null as string | null,
  });

  const [values, setValues] = useState({
    ContactPersons: [] as IContact[],
  });

  const [isDuplicate, setIsDuplicate] = useState<null | IClient>(null);

  const handleClick = (v: any, errors: any) => {
    setIsClickedToValidation(true);

    if (!client) {
      // createClient(
      //   {
      //     Address: v.Address ?? '',
      //     City: v.City ?? '',
      //     CityId: null,
      //     ContactPersons: values.ContactPersons,
      //     Email: v.Email ?? '',
      //     Id: null,
      //     IsInstitution: isInstitution ?? false,
      //     Name: v.Name ?? '',
      //     NewTags: [],
      //     NIP: isInstitution ? v.Nip ?? '' : '',
      //     Note: v.Note,
      //     Phone: v.Phone ?? '',
      //     REGON: v.IsInstitution ? v.REGON ?? '' : null,
      //     StreetId: null,
      //     TagIds: [],
      //     ZipCode: v.ZipCode ?? '',
      //   },
      //   {
      //     onSuccess: (response) => {
      //       setClients([response.data, ...clients].flat());
      //       onSave?.(response.data as ICase);
      //       onClose();
      //     },
      //     onError: (err: any) => {
      //       if (err?.response?.data?.duplicates) {
      //         setIsDuplicate(err?.response?.data?.duplicates?.[0]);
      //       }
      //     },
      //   }
      // );
      return;
    }

    updateClient(
      {
        Id: client?.Id,
        Address: v.Address ?? "",
        City: v.City ?? "",
        CityId: "none",
        ContactPersons: values.ContactPersons,
        Email: client?.Email ?? "",
        IsInstitution: isInstitution ?? false,
        Name: v.Name,
        NewTags: [],
        NIP: isInstitution ? v.Nip ?? "" : "",
        Note: v.Note ?? "",
        Phone: v.Phone ?? "",
        REGON: v.IsInstitution ? v.REGON ?? "" : "",
        StreetId: "none",
        TagIds: [],
        ZipCode: v.ZipCode ?? "",
      },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );
  };

  // const buttonSaveIsDisabled = () => {
  //   if (values.IsInstitution) {
  //     if (
  //       !values.Nip.length ||
  //       !values.REGON.length ||
  //       !values.Name.length ||
  //       !values.ZipCode.length ||
  //       !values.City.length ||
  //       !values.Address.length
  //     ) {
  //       return true;
  //     }

  //     if (!values.Email.length && !values.Phone.length) {
  //       return true;
  //     }

  //     return false;
  //   } else {
  //     if (
  //       !values.Name.length ||
  //       !values.ZipCode.length ||
  //       !values.City.length ||
  //       !values.Address.length
  //     ) {
  //       return true;
  //     }

  //     if (!values.Email.length && !values.Phone.length) {
  //       return true;
  //     }

  //     return false;
  //   }

  //   return false;
  // };

  const addNewPerson = () => {
    setValues({
      ...values,
      ContactPersons: [
        ...values.ContactPersons,
        {
          FirstName: "",
          LastName: "",
          Phone: "",
          JobPosition: "",
          Email: "",
        },
      ],
    });
  };

  const [isClickedToValidation, setIsClickedToValidation] = useState(false);

  const changeContactData = (index: number, type: string, text: string) => {
    const newArray = { ...values };

    const person = newArray.ContactPersons.at(index);

    if (!person) return;

    if (type === "name") {
      const name = text.split(" ");

      person.FirstName = name[0];
      person.LastName = name[1] ?? "";
    }
    if (type === "phone") {
      person.Phone = text;
    }
    if (type === "email") {
      person.Email = text;
    }

    setValues(newArray);
  };

  const deleteContact = (index: number) => {
    const newArray = { ...values };

    const persons = newArray.ContactPersons.filter((person, i) => {
      return i !== index;
    });

    newArray.ContactPersons = persons;

    setValues(newArray);
  };

  const [company, setCompany] = useState<IGUSCompany | null>(null);

  // const handleGUSData = (company: IGUSCompany) => {
  //   setValues({
  //     ...values,
  //     Name: company.Name,
  //     REGON: company.Regon,
  //     ZipCode: company.ZipCode,
  //     City: company.Place,
  //     Address: company.Street,
  //   });
  //
  // };

  const [isInstitution, setIsInstitution] = useState(false);

  const Observer = () => {
    const { setFieldValue, validateForm } = useFormikContext();

    useEffect(() => {
      if (!company) return;
      setFieldValue("Name", company.Name.replaceAll("#", ""));
      setFieldValue("REGON", company.Regon);
      setFieldValue("ZipCode", company.ZipCode);
      setFieldValue("City", company.Place);
      setFieldValue("Address", company.Street);
      setTimeout(() => {
        validateForm();
      }, 100);
    }, [company]);

    return <></>;
  };

  const Duplicate = () => {
    return (
      <div className={styles.card}>
        <div className={styles.wrapper}>
          <div className={styles.title}>{t("client.entityDuplicate")}</div>
          <div className={styles.box}>
            <div className={styles.t}>{t("forms.nip")}:</div>
            <div className={styles.v}>{isDuplicate?.NIP}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("forms.regon")}:</div>
            <div className={styles.v}>
              {isDuplicate?.REGON?.length ? isDuplicate?.REGON : "-"}
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("common.name")}:</div>
            <div className={styles.v}>{isDuplicate?.Name}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("common.address")}:</div>
            <div className={styles.v}>{isDuplicate?.Address}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("forms.zipCode")}:</div>
            <div className={styles.v}>{isDuplicate?.ZipCode}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("forms.email")}:</div>
            <div className={styles.v}>{isDuplicate?.Email}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.t}>{t("forms.phoneNumber")}:</div>
            <div className={styles.v}>{isDuplicate?.Phone}</div>
          </div>
          <div className={styles.btn}>
            <Button onClick={() => setIsDuplicate(null)} text={t("common.back")} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        width: `${sizes.leftPanel + 12}%`,
      }}
      className={styles.modal}
    >
      {isDuplicate && <Duplicate />}
      <div
        style={{ display: `${isDuplicate ? "none" : "block"}` }}
        className={styles.card}
      >
        <div className={styles.wrapper}>
          <div className={styles.title}>
            {label ? label : t("client.editEntity")}

            <CloseIcon onClick={onClose} className={styles.closeIcon} />
          </div>
          <div className={styles.checkboxes}>
            <SecondCheckbox
              value={isInstitution === false ? true : false}
              text={t("common.person")}
              onChange={() => setIsInstitution(false)}
            />
            <SecondCheckbox
              value={isInstitution === true ? true : false}
              text={t("admin.company")}
              onChange={() => setIsInstitution(true)}
            />
          </div>
          <Formik
            initialValues={metData}
            validationSchema={
              isInstitution ? validationSchemaEntity : validationSchemaClient
            }
            onSubmit={() => {}}
            validateOnMount
          >
            {({
              values: metaData,
              errors,
              touched,
              isValid,
              setFieldValue,
              setFieldTouched,
              validateForm,
            }) => (
              <>
                <Observer />
                <div className={styles.inputs}>
                  {isInstitution && (
                    <div className={styles.group}>
                      <SearchByNip
                        onBlur={() => setFieldTouched("Nip", true)}
                        isError={touched.Nip ? (errors.Nip as string) : ""}
                        onDataChange={(c) => setCompany(c)}
                        defaultValue={metaData.Nip}
                        onChange={(text) => {
                          setFieldValue("Nip", text);
                        }}
                      />

                      <Input
                        // isError={''}
                        isError={touched.REGON ? (errors.REGON as string) : ""}
                        label={t("forms.regon")}
                        value={metaData.REGON}
                        onBlur={() => setFieldTouched("REGON", true)}
                        onChange={(text) => {
                          setFieldValue("REGON", text);
                        }}
                      />
                    </div>
                  )}
                  {isInstitution ? (
                    <TextArea
                      isError={touched.Name ? (errors.Name as string) : ""}
                      label={t("client.entityName")}
                      value={metaData.Name}
                      onChange={(text) => {
                        setFieldValue("Name", text);
                        setFieldTouched("Name", true);
                      }}
                    />
                  ) : (
                    <Input
                      isError={touched.Name ? (errors.Name as string) : ""}
                      label={t("forms.fullName")}
                      value={metaData.Name}
                      onBlur={() => setFieldTouched("Name", true)}
                      onChange={(text) => {
                        setFieldValue("Name", text);
                      }}
                    />
                  )}

                  <div className={styles.group}>
                    <SearchCode
                      isError={
                        isClickedToValidation ? (errors.ZipCode as string) : ""
                      }
                      defaultValue={metaData.ZipCode}
                      // onBlur={() => setFieldTouched('ZipCode', true)}
                      onChange={(text) => {
                        setFieldValue("ZipCode", text);
                        // setFieldTouched('ZipCode', true);
                      }}
                    />
                    <SearchPlace
                      isError={
                        isClickedToValidation ? (errors.City as string) : ""
                      }
                      defaultValue={metaData.City}
                      onBlur={() => setFieldTouched("City", true)}
                      onChange={(text, c) => {
                        setFieldValue("City", text);
                        setFieldValue("cityId", c);

                        setFieldTouched("City", true);
                      }}
                    />
                  </div>
                  <SearchAddress
                    isError={
                      isClickedToValidation ? (errors.Address as string) : ""
                    }
                    defaultValue={metaData.Address}
                    cityId={metaData.cityId}
                    onBlur={() => setFieldTouched("Address", true)}
                    onChange={(text, c) => {
                      setFieldValue("Address", text);
                      setFieldValue("StreetId", c);
                    }}
                  />
                  <div className={styles.group}>
                    <Input
                      onBlur={() => setFieldTouched("Phone", true)}
                      isError={touched.Phone ? (errors.Phone as string) : ""}
                      className={styles.fix}
                      label={t("forms.phoneNumber")}
                      defaultValue={metaData.Phone}
                      onChange={(text) => {
                        setFieldTouched("Phone", true);
                        setFieldValue("Phone", text);
                      }}
                    />
                    <Input
                      isError={touched.Email ? (errors.Email as string) : ""}
                      className={styles.fix}
                      label={t("forms.email")}
                      defaultValue={metaData.Email}
                      onBlur={() => setFieldTouched("Email", true)}
                      onChange={(text) => {
                        setFieldValue("Email", text);
                      }}
                    />
                  </div>
                  <TextArea
                    label={t("forms.notes")}
                    defaultValue={metaData.Note}
                    onChange={(text) => setFieldValue("Note", text)}
                  />
                </div>

                <div className={styles.contacts}>
                  {values.ContactPersons.map((contact, index) => {
                    return (
                      <div className={styles.contact} key={index}>
                        <div className={styles.contactInputs}>
                          <div className={styles.inpute}>
                            <Input
                              label={t("forms.fullName")}
                              defaultValue={`${
                                contact.FirstName.length ? (
                                  <>contact.FirstName contact.LastName</>
                                ) : (
                                  ""
                                )
                              }`}
                              onChange={(text) =>
                                changeContactData(index, "name", text)
                              }
                            />
                            <div className={styles.removeWrapper}>
                              <BinIcon onClick={() => deleteContact(index)} />
                            </div>
                          </div>
                          <div className={styles.contactGroup}>
                            <Input
                              label={t("forms.phoneNumber")}
                              placeholder={t("forms.phoneNumber")}
                              defaultValue={`${contact.Phone}`}
                              onChange={(text) =>
                                changeContactData(index, "phone", text)
                              }
                            />
                            <Input
                              label={t("forms.emailAddress")}
                              placeholder={t("forms.emailAddress")}
                              defaultValue={`${contact.Email}`}
                              onChange={(text) =>
                                changeContactData(index, "email", text)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {!onCancel ? (
                  <div className={styles.buttonWrapper}>
                    {isInstitution && (
                      <div onClick={addNewPerson} className={styles.addButton}>
                        {t("client.addContactPerson")}
                      </div>
                    )}
                    <Button
                      disabled={!isValid}
                      text={t("common.create")}
                      handleError={() => validateForm()}
                      onClick={() => handleClick(metaData, errors)}
                    />
                  </div>
                ) : (
                  <div className={styles.buttonWrapper2}>
                    <Button
                      text={t("common.save")}
                      onClick={() => handleClick(metaData, errors)}
                    />
                  </div>
                )}
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default EditClientModal;
